import { render } from "./App.vue?vue&type=template&id=a7c53bbc&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/jacob/Work/clevero/trunk/www/frontend/CID/poski/klasik-2020/js/libraries/product-variants/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__